import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ShoppingPlannerContext } from '../Context/ShoppingPlannerContext';

export const useValuesFromParameters = () => {
    const { setSelectedDecor, setFloorFilter, floors } = useContext(ShoppingPlannerContext);

    const { floorFamilyId, floorDecorArticleNumber } = useParams<{
        floorFamilyId?: string;
        floorDecorArticleNumber?: string;
    }>();

    useEffect(() => {
        if (floorFamilyId) {
            setFloorFilter({ selectedFloorIds: [floorFamilyId], textFilter: '' });
        }

        if (floorDecorArticleNumber) {
            const floor = floors.find((floor) =>
                floor.decors.some((decor) => decor.articleNumber === floorDecorArticleNumber)
            );

            if (floor) {
                setFloorFilter({ selectedFloorIds: [floor.floorFamilyId], textFilter: '' });
                setSelectedDecor(floorDecorArticleNumber);
            }
        }
    }, [floorFamilyId, floorDecorArticleNumber, floors]);
};
